import React, { createContext, useState } from 'react';
import axios from 'axios';
import {
  onAddMerchantDocAPI,
  onGetMerchantDocAPI,
  onUpdateMerchantDocAPI,
  onUploadMerchantDocCloudinaryAPI,
} from './../api-services/MerchantDocument.services';
import { API_NETWORK_ERROR, localStorageKeys } from '../../utils/constants';

export const MerchantDocContext = createContext();
const MerchantDocDataProvider = ({ children }) => {
  const { TOKEN } = localStorageKeys;
  const [addMerchantDocResponse, setAddMerchantDocResponse] = useState({
    loading: false,
    success: null,
    message: null,
    data: null,
  });

  const [getMerchantDocResponse, setGetMerchantDocResponse] = useState({
    loading: false,
    success: null,
    message: null,
    data: null,
  });

  const [updateMerchantDocResponse, setUpdateMerchantDocResponse] = useState({
    loading: false,
    success: null,
    message: null,
    data: null,
  });

  const [uploadMerchantDocCloudinaryResponse, setUploadMerchantDocCloudinaryResponse] = useState({
    loading: false,
    success: null,
    message: null,
    data: null,
  });

  const AddMerchantDoc = async (payload) => {
    try {
      const gettingToken = localStorage.getItem(TOKEN);
      if (gettingToken) {
        axios.defaults.headers.common.Authorization = `Bearer ${gettingToken}`;
      } else {
        setAddMerchantDocResponse({
          success: false,
          loading: false,
          data: null,
          errorMessage: 'Token & Refresh Token missing',
        });
        return;
      }

      await setAddMerchantDocResponse({
        loading: true,
        success: null,
        message: null,
        data: null,
      });

      const data = await onAddMerchantDocAPI(payload);

      if (data.hasError) {
        await setAddMerchantDocResponse({
          loading: false,
          data: null,
          success: !data.hasError,
          message: data.message,
        });
        return;
      }

      if (data.data?.success) {
        await setAddMerchantDocResponse({
          loading: false,
          data: data,
          success: data.data?.success,
          message: data.data?.message,
        });
      } else {
        await setAddMerchantDocResponse({
          loading: false,
          data: data,
          success: data.data?.success,
          message: data.data?.message,
        });
      }
      return;
    } catch (error) {
      console.log('---Catch black AddMerchantDoc', error);
      setAddMerchantDocResponse({ loading: false, data: null, success: false, message: error });
    }
  };

  const GetMerchantDoc = async (payload) => {
    try {
      const gettingToken = localStorage.getItem(TOKEN);
      if (gettingToken) {
        axios.defaults.headers.common.Authorization = `Bearer ${gettingToken}`;
      } else {
        setGetMerchantDocResponse({
          success: false,
          loading: false,
          data: null,
          errorMessage: 'Token & Refresh Token missing',
        });
        return;
      }

      await setGetMerchantDocResponse({
        loading: true,
        success: null,
        message: null,
        data: null,
      });

      const data = await onGetMerchantDocAPI(payload);

      if (data.hasError) {
        await setGetMerchantDocResponse({
          loading: false,
          data: null,
          success: !data.hasError,
          message: data.message,
        });
        return;
      }

      if (data.data?.success) {
        await setGetMerchantDocResponse({
          loading: false,
          data: data,
          success: data.data?.success,
          message: data.data?.message,
        });
      } else {
        await setGetMerchantDocResponse({
          loading: false,
          data: data,
          success: data.data?.success,
          message: data.data?.message,
        });
      }
      return data;
    } catch (error) {
      console.log('---Catch black GetMerchantDoc', error);
      setGetMerchantDocResponse({ loading: false, data: null, success: false, message: error });
    }
  };

  const UpdateMerchantDoc = async (payload) => {
    try {
      const gettingToken = localStorage.getItem(TOKEN);
      if (gettingToken) {
        axios.defaults.headers.common.Authorization = `Bearer ${gettingToken}`;
      } else {
        setUpdateMerchantDocResponse({
          success: false,
          loading: false,
          data: null,
          errorMessage: 'Token & Refresh Token missing',
        });
        return;
      }

      await setUpdateMerchantDocResponse({
        loading: true,
        success: null,
        message: null,
        data: null,
      });

      const data = await onUpdateMerchantDocAPI(payload);

      if (data.hasError) {
        await setUpdateMerchantDocResponse({
          loading: false,
          data: null,
          success: !data.hasError,
          message: data.message,
        });
        return data;
      }

      if (data.data?.success) {
        await setUpdateMerchantDocResponse({
          loading: false,
          data: data,
          success: data.data?.success,
          message: data?.data?.message || data?.data?.customMessage,
        });
      } else {
        await setUpdateMerchantDocResponse({
          loading: false,
          data: data,
          success: data?.data?.success,
          message: data?.data?.message || data?.data?.customMessage,
        });
      }
      return data;
    } catch (error) {
      console.log('---Catch black UpdateMerchantDoc', error);
      setUpdateMerchantDocResponse({ loading: false, data: null, success: false, message: error });
    }
  };

  const UploadMerchantDocCloudinary = async (payload) => {
    try {
      const gettingToken = localStorage.getItem(TOKEN);
      if (gettingToken) {
        axios.defaults.headers.common.Authorization = `Bearer ${gettingToken}`;
      } else {
        setUploadMerchantDocCloudinaryResponse({
          success: false,
          loading: false,
          data: null,
          errorMessage: 'Token & Refresh Token missing',
        });
        return;
      }

      await setUploadMerchantDocCloudinaryResponse({
        loading: true,
        success: null,
        message: null,
        data: null,
      });

      const data = await onUploadMerchantDocCloudinaryAPI(payload);

      if (data?.hasError) {
        await setUploadMerchantDocCloudinaryResponse({
          loading: false,
          data: null,
          success: !data.hasError,
          message: data.message,
        });
        return data;
      }

      if (data?.data?.success) {
        await setUploadMerchantDocCloudinaryResponse({
          loading: false,
          data: data,
          success: data.data?.success,
          message: data.data?.message,
        });
      } else {
        await setUploadMerchantDocCloudinaryResponse({
          loading: false,
          data: data,
          success: data.data?.success,
          message: data.data?.message,
        });
      }
      return data;
    } catch (error) {
      console.log('---Catch black UploadMerchantDocCloudinary', error);
      setUploadMerchantDocCloudinaryResponse({
        loading: false,
        data: null,
        success: false,
        message: error,
      });
    }
  };

  return (
    <MerchantDocContext.Provider
      value={{
        addMerchantDocResponse,
        setAddMerchantDocResponse,
        AddMerchantDoc,

        GetMerchantDoc,
        getMerchantDocResponse,
        setGetMerchantDocResponse,

        UpdateMerchantDoc,
        updateMerchantDocResponse,
        setUpdateMerchantDocResponse,

        UploadMerchantDocCloudinary,
        uploadMerchantDocCloudinaryResponse,
        setUploadMerchantDocCloudinaryResponse,
      }}
    >
      {children}
    </MerchantDocContext.Provider>
  );
};

export default MerchantDocDataProvider;
